var AS2MouseAdapter = (function () {
    function AS2MouseAdapter() {
    }
    // this does nothing really, just to catch usage in scripts
    AS2MouseAdapter.addListener = function (listener) {
        AS2MouseAdapter._globalListeners.push(listener);
        // TODO: Init actual mouse events here, relative to root MovieClip (I suppose?)
    };
    return AS2MouseAdapter;
}());
export { AS2MouseAdapter };
AS2MouseAdapter._globalListeners = [];



// WEBPACK FOOTER //
// ../dist/lib/adapters/AS2MouseAdapter.js